import { Suspense, lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import BootSplash from '@/shared/components/BootSplash';
import ROUTES from '@/shared/constants/routes';

/**
 * Ruta del host de producción de onboarding v3. UN solo componente dueño del
 * estado bajo `/onboarding/:nodeId?` — el `:nodeId` es la PROYECCIÓN de
 * state.position, no una fuente de navegación. Es una sola ruta con param
 * opcional (no parent+child) a propósito: cambiar de nodo re-renderiza el MISMO
 * elemento sin desmontarlo, así el owner conserva su estado en memoria a lo
 * largo de todo el flow. Se monta en el mismo árbol autenticado que
 * `/onboarding-v2`. Queda viva pero inalcanzable en este PR (nadie navega aquí
 * todavía): ese es el diseño de fase 1.
 */

const OnboardingV3Host = lazy(() => import('./OnboardingV3Host'));

export const onboardingV3Routes: RouteObject = {
	id: 'onboarding-v3',
	path: `${ROUTES.ONBOARDING_V3}/:nodeId?`,
	element: (
		<Suspense fallback={<BootSplash />}>
			<OnboardingV3Host />
		</Suspense>
	),
};
